import React from 'react';
import PropTypes from 'prop-types';
import BalanceIcon from 'resources/ui-icon-balance-chip.svg';
import SapphireIcon from 'resources/icons-currency-sapphire-sml.png';
import TicketIcon from 'resources/ui-icon-ticket-currency.png';
import TrophyIcon from 'resources/icons-trophy.png';
import WScoreIcon from 'resources/ui-icon-wscore.png';

const typeData = {
  sapphires: {
    src: SapphireIcon,
    title: 'Sapphires'
  },
  wscore: {
    src: WScoreIcon,
    title: 'WScore'
  },
  tickets: {
    src: TicketIcon,
    title: 'Online Entries'
  },
  balance: {
    src: BalanceIcon,
    title: 'Game Balance'
  },
  gamePoints: {
    src: TrophyIcon,
    title: 'Game Points'
  }
};

function CurrencyIcon({ type, className }) {
  const data = typeData[type];
  if (!data) {
    return null;
  }
  return (
    <img
      className={className}
      src={data.src}
      alt={data.title}
      title={data.title}
    />
  );
}

CurrencyIcon.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['sapphires', 'wscore', 'tickets', 'balance'])
};

export default CurrencyIcon;
